import PolygonBase from './PolygonBase';
import shapeParallelogram from '../assets/icons/shapeParallelogram.svg';
import { svgToIcon } from '../utils/svg';
import { AttachmentPoint } from '../types';

class ShapeParallelogram extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeParallelogram);
  }

  static connectControlDefinition() {
    return {
      ...super.connectControlDefinition(),

      cl: {
        x: -0.4,
        y: 0,
        normal: { x: -1, y: 0 },
        oppositeAttachmentPoint: AttachmentPoint.Right,
      },
      cr: {
        x: 0.4,
        y: 0,
        normal: { x: 1, y: 0 },
        oppositeAttachmentPoint: AttachmentPoint.Left,
      },
    };
  }

  calcTextMargin() {
    const { width } = this.fabricObject;

    return {
      top: 5,
      left: 0.2 * width,
      right: 0.2 * width,
      bottom: 5,
    };
  }

  static pathString() {
    return `
      M -0.5 0.5
      L 0.3 0.5
      L 0.5 -0.5
      L -0.3 -0.5
      Z
    `;
  }

  static iconClass() {
    return 'fa-regular fa-square';
  }
}

export default ShapeParallelogram;
